import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const Footer = () => {
    return (
    <div>

   
        <div className="footer-area footer-padding">
            <div className="container">
                <div className="row d-flex justify-content-between">
                    <div className="col-xl-3 col-lg-3 col-md-5 col-sm-6">
                        <div className="single-footer-caption mb-50">
                            <div className="single-footer-caption mb-30">
                              
                                <div className="footer-logo">
                                    <a href=""><img src="assets/img/logo/logo-fotter.png" alt=""/></a>
                                </div>
                                <div className="footer-tittle">
                                    <div className="footer-pera">
                                        <p className="text-primary">Asian Watch Store  is a trading name of The Watch Shop Holdings Limited.
WatchShop™ is a registered trademark © 2021 -  All rights reserved. It's  is the Bagladeshi company sale world  No. 1 Products in online.</p>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-2 col-lg-3 col-md-3 col-sm-5">
                        <div className="single-footer-caption mb-50">
                            <div className="footer-tittle">
                                <h4>Quick Links</h4>
                                <ul>
                                    <li><a href="#">About</a></li>
                                    <li><a href="#"> Offers & Discounts</a></li>
                                    <li><a href="#"> Get Coupon</a></li>
                                    <li><a href="#">  Contact Us</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-7">
                        <div className="single-footer-caption mb-50">
                            <div className="footer-tittle">
                                <h4>New Products</h4>
                                <ul>
                                    <li><a href="#">Woman Cloth</a></li>
                                    <li><a href="#">Fashion Accessories</a></li>
                                    <li><a href="#"> Man Accessories</a></li>
                                    <li><a href="#"> Rubber made Toys</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-5 col-sm-7">
                        <div className="single-footer-caption mb-50">
                            <div className="footer-tittle">
                                <h4>Support</h4>
                                <ul>
                                    <li><a href="#">Frequently Asked Questions</a></li>
                                    <li><a href="#">Terms & Conditions</a></li>
                                    <li><a href="#">Privacy Policy</a></li>
                                    <li><a href="#">Report a Payment Issue</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row align-items-center">
                    <div className="col-xl-7 col-lg-8 col-md-7">
                        <div className="footer-copy-right">
                            <p>
  Copyright &copy;<script>document.write(new Date().getFullYear());</script> All rights reserved  <i className="fa fa-heart" aria-hidden="true"> Develop</i> by Moinuddin</p>
 
                    </div>
                    <div className="col-xl-5 col-lg-4 col-md-5">
                        <div className="footer-copy-right f-right">
                           
                            <div className="footer-social">
                                <a href="#"><i className="fab fa-twitter"></i></a>
                                <a href="https://www.facebook.com/sai4ull"><i className="fab fa-facebook-f"></i></a>
                                <a href="#"><i className="fab fa-behance"></i></a>
                                <a href="#"><i className="fas fa-globe"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        </div>
        </div> 
       
    );
};

export default Footer;